<template>
	<div
		@click="shareMyWorkflow"
		class="item item-with-icon option"
		:class="{disabled: isDisabled}"
		:disabled="isDisabled"
	>
		<base-icon icon-name="share" iconColor="#8c8c8c" />
		<span class="no-child">Share Experiment</span>
	</div>
</template>

<script>
import OptionModal from './option-modal';
import {trackEvent} from '@/services/tracking.js';

export default {
	name: 'MoreOptionsShareWorkflow',
	components: {OptionModal},
	props: {
		currentWorkflow: {type: Object},
	},
	computed: {
		isDisabled() {
			return !this.$store.state.enableShareUrl;
		},
	},
	methods: {
		shareMyWorkflow() {
			const {id, title, data: document} = this.currentWorkflow;
			const publication_id = this.$store.state.hcube.publication_id;
			this.$store.commit('featureShare/openModal', {id, title, document, publication_id});
			this.trackShare();
		},
		trackShare() {
			trackEvent('ctaClick', {eVar58: 'Share workflow| Workflow Configurator'});
		},
	},
};
</script>
<style lang="scss" scoped>
.item {
	font-weight: 400;
	font-style: normal;
	font-size: 16px;
	white-space: pre-line;

	&.item-with-icon .icons {
		margin-right: 23px;
	}
}
</style>
